module.exports = {"patient":{"menu-banners":{"queue-instant-video":"O seu pedido de Consulta Imediata por Vídeo está aguardando atendimento. ","queue-written":"Sua solicitação de Consulta Escrita está aguardando atendimento. \nVocê receberá uma notificação quando o profissional aceitar sua consulta.","queue-chat":"Sua solicitação de bate-papo está aguardando para ser atendida. ","queue-call":"Sua solicitação de chamada está aguardando para ser atendida. ","new-chat-messages":"Você tem novas mensagens de bate-papo. "}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/patient/menu-banners.json
// module id = 622
// module chunks = 116